import { render, staticRenderFns } from "./th-quarternary.vue?vue&type=template&id=2471e3f4&scoped=true&"
import script from "./th-quarternary.vue?vue&type=script&lang=js&"
export * from "./th-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471e3f4",
  null
  
)

export default component.exports